@if (transaction(); as transaction) {
  @if (transaction.sourceType === 'CLUSTER') {
    <ng-container [ngTemplateOutlet]="leaReport"></ng-container>
  } @else {
    @switch (transaction.type) {
      @case ('INCOMING') {
        <app-transaction-incoming [transaction]="transaction" [process]="process()"></app-transaction-incoming>
      }
      @case ('TRANSACTION_SCAN') {
        <app-transaction-scan [transaction]="transaction"></app-transaction-scan>
      }
      @case ('OUTCOMING') {
        <app-transaction-outcoming [transaction]="transaction" [process]="process()"></app-transaction-outcoming>
      }
      @case ('WALLET_SCAN') {
        <app-wallet-scan [transaction]="transaction"></app-wallet-scan>
      }
      @case ('BLOCKING') {
        <ng-container [ngTemplateOutlet]="leaReport"></ng-container>
      }
    }
  }
  <ng-template #leaReport>
    @if (userRole() === 'POLICE' && !transaction.clusterName) {
      <app-lea-short-report [transactionInput]="transaction"></app-lea-short-report>
    } @else {
      <app-lea-case [transactionInput]="transaction"></app-lea-case>
    }
  </ng-template>
} @else {
  No data
}

